module.exports = __webpack_public_path__ + "static/media/img29.d2a9d381.jpg";